import { render, staticRenderFns } from "./EventConferenceDataContainer.vue?vue&type=template&id=3397e43f&scoped=true"
import script from "./EventConferenceDataContainer.vue?vue&type=script&lang=js"
export * from "./EventConferenceDataContainer.vue?vue&type=script&lang=js"
import style0 from "./EventConferenceDataContainer.vue?vue&type=style&index=0&id=3397e43f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3397e43f",
  null
  
)

export default component.exports